__turbopack_context__.v({
  "brand": "n6F9FG_brand",
  "contact": "n6F9FG_contact",
  "header": "n6F9FG_header",
  "link": "n6F9FG_link",
  "links": "n6F9FG_links",
  "logo": "n6F9FG_logo",
  "menuButton": "n6F9FG_menuButton",
  "menuIcon": "n6F9FG_menuIcon",
  "nav": "n6F9FG_nav",
  "search": "n6F9FG_search",
  "wordmark": "n6F9FG_wordmark",
  "wordmarkAi": "n6F9FG_wordmarkAi",
});
